(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart-pie.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"radius");
frame.set("radius", t_1, true);
if(frame.topLevel) {
context.setVariable("radius", t_1);
}
if(frame.topLevel) {
context.addExport("radius", t_1);
}
output += " ";
var t_2;
t_2 = ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth") - runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength")) / 2);
frame.set("xOffset", t_2, true);
if(frame.topLevel) {
context.setVariable("xOffset", t_2);
}
if(frame.topLevel) {
context.addExport("xOffset", t_2);
}
output += " ";
var t_3;
t_3 = ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight") - runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength")) / 2);
frame.set("yOffset", t_3, true);
if(frame.topLevel) {
context.setVariable("yOffset", t_3);
}
if(frame.topLevel) {
context.addExport("yOffset", t_3);
}
output += " <svg height=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight")) * 100, env.opts.autoescape);
output += "%\" class=\"pie-chart\" width=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth")) * 100, env.opts.autoescape);
output += "%\" viewBox=\"0 0 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength"), env.opts.autoescape);
output += "\" x=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xOffset"), env.opts.autoescape);
output += "\" y=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yOffset"), env.opts.autoescape);
output += "\"> ";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"pies");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("pie", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += " ";
if(runtime.memberLookup((t_7),"radius")) {
output += " ";
var t_8;
t_8 = runtime.memberLookup((t_7),"radius");
frame.set("radius", t_8, true);
if(frame.topLevel) {
context.setVariable("radius", t_8);
}
if(frame.topLevel) {
context.addExport("radius", t_8);
}
output += " ";
;
}
output += " ";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_7),"values")),0)),"v");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("pieSlice", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += " ";
if(runtime.memberLookup((t_12),"value")) {
output += " ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.memberLookup((runtime.memberLookup((t_7),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")));
frame.set("valueMap", t_13, true);
if(frame.topLevel) {
context.setVariable("valueMap", t_13);
}
if(frame.topLevel) {
context.addExport("valueMap", t_13);
}
output += " ";
if((runtime.memberLookup((t_12),"value") / runtime.memberLookup((t_7),"total")) == 1) {
output += " <circle cx=\"50%\" cy=\"50%\" r=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius"), env.opts.autoescape);
output += "\" fill=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "valueMap")),"color"), env.opts.autoescape);
output += "\"/> ";
;
}
else {
output += " <path fill=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "valueMap")),"color"), env.opts.autoescape);
output += "\" class=\"pie-chart-slice\" d=\"M ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / 2, env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / 2, env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"startPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"startPosition")),"y"), env.opts.autoescape);
output += " A ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius"), env.opts.autoescape);
output += " 0 ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"largeArcFlag"), env.opts.autoescape);
output += " 1 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"endPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"endPosition")),"y"), env.opts.autoescape);
output += " Z\"> </path> ";
;
}
output += " ";
;
}
output += " ";
;
}
}
frame = frame.pop();
output += " ";
;
}
}
frame = frame.pop();
output += " </svg>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
